import React, { Fragment }from "react"
import {
    Card,
    CardBody,
    CardHeader
} from "reactstrap";
import moment from "moment";


class SpouseDependants extends React.Component {

    render() {
        
        const {
            client
        } = this.props;

        return (
            <>
                <Card>
                  <CardHeader>
                    <h3>Spouse Information</h3>
                  </CardHeader>
                  <CardBody>
                    <div className="typography-line">
                      <h4>
                        <span>First Name</span>
                        {client.spouse.first_name || "N/A"}
                      </h4>
                    </div>
                    <div className="typography-line">
                      <h4>
                        <span>Last Name</span>
                        {client.spouse.last_name || "N/A"}
                      </h4>
                    </div>
                    <div className="typography-line">
                      <h4>
                        <span>Middle Name</span>
                        {client.spouse.middle_name || "N/A"}
                      </h4>
                    </div>
                    <div className="typography-line">
                      <h4>
                        <span>Gender</span>
                        {client.spouse.gender || "N/A"}
                      </h4>
                    </div>
                    <div className="typography-line">
                      <h4>
                        <span>Birthday</span>
                        {client.spouse.birthday
                          ? moment(client.birthday).format(
                              "MM/DD/YYYY"
                            )
                          : "N/A"}
                      </h4>
                    </div>
                    <div className="typography-line">
                      <h4>
                        <span>Age</span>
                        {client.spouse.age || "N/A"}
                      </h4>
                    </div>
                    <div className="typography-line">
                      <h4>
                        <span>Nationality</span>
                        {client.spouse.nationality || "N/A"}
                      </h4>
                    </div>
                    <div className="typography-line">
                      <h4>
                        <span>Email</span>
                        {client.spouse.email || "N/A"}
                      </h4>
                    </div>
                    <div className="typography-line">
                      <h4>
                        <span>Phone</span>
                        {client.spouse.phone || "N/A"}
                      </h4>
                    </div>
                    <div className="typography-line">
                      <h4>
                        <span>Address</span>
                        {client.spouse.address || "N/A"}
                      </h4>
                    </div>
                  </CardBody>
                </Card>
                <Card>
                  <CardHeader>
                    <h3>Spouse Work and Occupation</h3>
                  </CardHeader>
                  <CardBody>
                    <div className="typography-line">
                      <h4>
                        <span>Occupation</span>
                        {client.spouseOccupation.occupation ||
                          "N/A"}
                      </h4>
                    </div>
                    <div className="typography-line">
                      <h4>
                        <span>Business/Company Name</span>
                        {client.spouseOccupation.companyName ||
                          "N/A"}
                      </h4>
                    </div>
                    <div className="typography-line">
                      <h4>
                        <span>Company Address</span>
                        {client.spouseOccupation.companyAddress ||
                          "N/A"}
                      </h4>
                    </div>
                    <div className="typography-line">
                      <h4>
                        <span>Contact Number/Mobile</span>
                        {client.spouseOccupation.companyContact ||
                          "N/A"}
                      </h4>
                    </div>
                    <div className="typography-line">
                      <h4>
                        <span>Company Email Address</span>
                        {client.spouseOccupation.companyEmail ||
                          "N/A"}
                      </h4>
                    </div>
                    <div className="typography-line">
                      <h4>
                        <span>Nature of Business</span>
                        {client.spouseOccupation.businessNature ||
                          "N/A"}
                      </h4>
                    </div>
                    <div className="typography-line">
                      <h4>
                        <span>Position Held</span>
                        {client.spouseOccupation.jobTitle ||
                          "N/A"}
                      </h4>
                    </div>
                    <div className="typography-line">
                      <h4>
                        <span>Years in Employment</span>
                        {client.spouseOccupation.experience ||
                          "N/A"}
                      </h4>
                    </div>
                  </CardBody>
                </Card>
                <Card>
                  <CardHeader>
                    <h3>Dependents</h3>
                  </CardHeader>
                  <CardBody>
                    {client.dependents &&
                    client.dependents.length > 0 ? (
                      client.dependents.map(
                        (dependent, index) => {
                          return (
                            <Fragment key={index}>
                              <h4>Dependent #{index + 1}</h4>
                              <div className="typography-line">
                                <h4>
                                  <span>Name</span>
                                  {dependent.name || "N/A"}
                                </h4>
                              </div>
                              <div className="typography-line">
                                <h4>
                                  <span>Birthday</span>
                                  {(dependent.birthday &&
                                    moment(
                                      dependent.birthday
                                    ).format("MM/DD/YYYY")) ||
                                    "N/A"}
                                </h4>
                              </div>
                              <div className="typography-line">
                                <h4>
                                  <span>Age</span>
                                  {dependent.age || "N/A"}
                                </h4>
                              </div>
                              <div className="typography-line">
                                <h4>
                                  <span>Relation</span>
                                  {dependent.relation || "N/A"}
                                </h4>
                              </div>
                            </Fragment>
                          );
                        }
                      )
                    ) : (
                      <div className="typography-line">
                        <h4>
                          <span>N/A</span>
                        </h4>
                      </div>
                    )}
                  </CardBody>
                </Card>
            </>
        )
    }
}

export default SpouseDependants;